import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import NavBar from './components/layout/NavBar';
import LandingDashboard from './components/landing/LandingDashboard';
import ReservationSchedule from './components/reservations/ReservationSchedule';
import MemberCustomerPage from './components/members/MemberCustomerPage';
import MemberCard from './components/members/MemberCard';
import CustomerCard from './components/members/CustomerCard';
import { SitesDashboard } from './components/sites';
import ConfigDashboard from './components/config/StoreManagement/ConfigDashboard';
import DailyReport from './components/reports/DailyReport';
import AnalysisRoutes from './components/analysis/AnalysisRoutes';
import { SessionProvider, ProtectedRoute, Login } from './services/auth';
import { SiteDataProvider } from './contexts/SiteDataContext';
import { ReservationDataProvider } from './contexts/ReservationDataContext';
import { MemberDataProvider } from './contexts/MemberDataContext';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <SessionProvider>
        <Routes>
          {/* Public route - Login */}
          <Route path="/login" element={<Login />} />

          {/* Protected routes */}
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <SiteDataProvider>
                  <ReservationDataProvider>
                    <MemberDataProvider>
                      <div className="app">
                        <NavBar />
                        <main className="main-content">
                          <Routes>
                            <Route path="/" element={<LandingDashboard />} />
                            <Route path="/reservations" element={<ReservationSchedule />} />
                            <Route path="/members" element={<MemberCustomerPage />} />
                            <Route path="/members/:memberId" element={<MemberCard />} />
                            <Route path="/customers/:customerId" element={<CustomerCard />} />
                            <Route path="/daily-report" element={<DailyReport />} />
                            <Route path="/analysis/*" element={<AnalysisRoutes />} />
                            <Route path="/sites" element={<SitesDashboard />} />
                            <Route path="/config" element={<ConfigDashboard />} />
                            <Route path="*" element={<Navigate to="/" replace />} />
                          </Routes>
                        </main>
                      </div>
                    </MemberDataProvider>
                  </ReservationDataProvider>
                </SiteDataProvider>
              </ProtectedRoute>
            }
          />
        </Routes>
      </SessionProvider>
    </BrowserRouter>
  );
}

export default App;
